import React from 'react';
import ContractualAccountFullDTO from 'features/contractualAccounts/dtos/ContractualAccountFullDTO';
import PageCard from 'features/shared/components/card/PageCard';
import InfoItem from 'features/shared/components/infoItem/InfoItem';
import { useTranslation } from 'react-i18next';
import ContactPersonDTO from 'features/contractualAccounts/dtos/ContactPersonDTO';
import ContactPerson from 'features/contractualAccounts/components/ContactPerson';
import { getPluralizedMessage } from 'features/shared/helpers/translationHelper';

const booleanMapping: Record<string, string> = {
  true: "Yes",
  false: "No"
}

interface Props {
  contractualAccount: ContractualAccountFullDTO;
  person: ContactPersonDTO;
}

const ContractualAccountInfoCard = ({ contractualAccount, person }: Props) => {
  // translations
  const tStatus = useTranslation(["contractualAccounts\\enums\\contractualAccountStatus"]).t;
  const tBillingCycle = useTranslation(["billings\\enums\\billingCycle"]).t;
  const tTerms = useTranslation(["shared\\terms"]).t;
  const tLabels = useTranslation("contractualAccounts\\contractualAccounts").t;
  const tDays = useTranslation(["shared\\days"]).t;

  // sub-renders
  const renderPerson = () => {
    return <ContactPerson person={person} />;
  }

  const renderDueDateSetting = () => { 
    if (contractualAccount.dueDateSettingMethod) {
      let result = contractualAccount.dueDateSettingMethod;
      if (contractualAccount.addingDaysOfDueDate) {
        
        result += ` + ${contractualAccount.addingDaysOfDueDate} ${getPluralizedMessage(tDays, "day", contractualAccount.addingDaysOfDueDate)}`;
      }

      return (
        <div className="col-12 px-sm-3 pb-2 pb-sm-3">
          <InfoItem title={tLabels("contractualAccountInfoCard.labels.dueDateSettingMethod")} value={result} icon="flag"  />
        </div>
      )
    }
  }

  // render
  return (
    <PageCard title={tLabels("contractualAccountInfoCard.cardTitle")} bodyClassName="pb-0">
      <div className="row no-gutters">
        <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem title={tLabels("contractualAccountInfoCard.labels.number")} value={contractualAccount.number} icon="tasks" />
        </div>
        <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem title={tLabels("contractualAccountInfoCard.labels.name")} value={contractualAccount.name ?? "-"} icon="plug"  />
        </div>
        <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem title={tLabels("contractualAccountInfoCard.labels.contactPerson")} value={renderPerson()} icon="user"  />  
        </div>
        <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem title={tLabels("contractualAccountInfoCard.labels.contractualAccountStatus")} value={tStatus(contractualAccount.contractualAccountStatus!)} icon="tag" />
        </div>
        <div className="col-sm-6 col-lg-4 px-sm-3 pb-2 pb-sm-3">
          <InfoItem title={tLabels("contractualAccountInfoCard.labels.billingCycle")} value={tBillingCycle(contractualAccount.billingCycle!)} icon="calendar-alt" />
        </div>
        <div className="col-auto px-sm-3 pb-2 pb-sm-3">
          <InfoItem title={tLabels("contractualAccountInfoCard.labels.taxPayer")} value={tTerms(booleanMapping[`${contractualAccount.taxPayer}`])} icon="donate" />
        </div>
        {renderDueDateSetting()}
      </div>
    </PageCard>
  )
}

export default ContractualAccountInfoCard;
